import { render, staticRenderFns } from "./commodity_order.vue?vue&type=template&id=7c17437c&"
import script from "./commodity_order.vue?vue&type=script&lang=js&"
export * from "./commodity_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports